<template lang="pug">
modal(:max-width="200")
	.card
		.card-header.bg-info.text-white
			span.fa.fa-info.mr-2
			| Nuevo producto
			button.close(@click="$emit('cerrar')") &times;
		.card-body
			.form-group
				label
					b Nombre del producto
				input.form-control(v-model="nombre")
		.card-footer
			button.btn.btn-primary(@click="crear")
				span.fa.fa-save.mr-2
				| Crear
</template>

<script>
import axios from 'axios'
export default {
	props: ['producto'],
	data () {
		return {
			nombre: null
		}
	},
	methods: {
		crear () {
			const datos = {
				soporte_ID: this.producto.soporte_ID,
				nombre: this.nombre
			}
			axios.post('gestion-tarifas/php/api/set-producto.php', datos)
				.then((e) => {
					this.$emit('nuevo', e.data.ID_producto)
					this.$emit('cerrar')
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/gestion-tarifas/vue/componentes/nuevoProducto.vue